// Removes every line item in a Full Set purchase together, so a shopper can't break a set
// apart in the cart-drawer/cart page by removing just one component (see cart-bundle-group.liquid).
// Delegated on document so it keeps working after cart-drawer re-renders its section HTML.
(function () {
  function getSectionsToBundle() {
    var sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections: sections },
      })
    );
    return sections;
  }

  async function removeBundle(keys) {
    var sections = getSectionsToBundle();
    var updates = {};
    keys.forEach(function (key) {
      updates[key] = 0;
    });

    var response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ updates: updates, sections: sections.join(',') }),
    });

    var responseJson = await response.json();
    var cartContent = await (await fetch(window.Shopify.routes.root + 'cart.js')).json();
    cartContent.sections = responseJson.sections;

    document.documentElement.dispatchEvent(
      new CustomEvent('cart:change', {
        bubbles: true,
        detail: { baseEvent: 'variant:remove', cart: cartContent },
      })
    );
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-remove-bundle]');
    if (!button) return;

    event.preventDefault();
    var keys = JSON.parse(button.getAttribute('data-bundle-keys') || '[]');
    if (!keys.length) return;

    button.setAttribute('disabled', 'disabled');
    removeBundle(keys).finally(function () {
      button.removeAttribute('disabled');
    });
  });
})();
